export function BracketsXIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7842 14C13.6677 14 14.3845 13.2328 14.3845 12.2855V8.85725L15.1846 8L14.3845 7.14275V3.7145C14.3845 2.76725 13.6684 2 12.7842 2M3.58489 2C2.70079 2 1.98468 2.76725 1.98468 3.7145V7.14275L1.18457 8L1.98468 8.85725V12.2855C1.98468 13.2328 2.70079 14 3.58489 14M10.2847 5.75L6.08462 10.25M6.08462 5.75L10.2847 10.25"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
